<template>
  <div class="items">
    <div
      v-for="(item, index) in items"
      :key="index"
      class="item"
    >
      <div class="item-element">
        <div class="item-image">
          <img
            :src="item.image.filepath"
          >
        </div>
      </div>
      <div class="item-element cart-item-content">
        <div class="item-sub-element">
          <div
            v-if="item.subTitle"
            class="item-subtitle"
          >
            {{ item.subTitle }}
          </div>
          <div
            v-if="item.title"
            class="item-title"
          >
            <h5>{{ item.title }}</h5>
          </div>
          <div
            v-if="item.description"
            class="item-description"
          >
            {{ item.description }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'display-list',
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>

.items {
  .item {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    justify-content: flex-start;
    .item-element {
      &:not(:last-child) {
        margin-right: .5em;
      }
    }
    .item-sub-element {
      &:not(:last-child) {
        margin-bottom: 0.75em;
      }
    }
  }
}

.item {
    &:not(:last-child) {
      margin-bottom: 1.25em;
    }
}

.item-title > * {
    margin:0;
    font-size:1.1em;
}
.item-description {
    font-size:.867em;
    line-height:1.3;
}
.item-image {
  width: 4em;
  height: 4em;
  display: flex;
  justify-content: center;
  img {
    object-fit: contain;
    width: 100%;
  }
}
</style>
